'use client';

import { useLayoutEffect } from 'react';
import {
  applyNavChromeDocumentAttributes,
  isNavChromeLogoutPending,
  NAV_CHROME_SNAPSHOT_KEY,
  writeNavChromeSnapshot,
  type NavChromeServices,
  type NavChromeUser,
} from '../navChromeBoot';

const LOGGED_OUT_SERVICES: NavChromeServices = { edge: false, pro: false, research: false };

export const useNavChromeRevalidate = (user: NavChromeUser, services: NavChromeServices, ready: boolean): void => {
  const { edge, pro, research } = services;
  useLayoutEffect(() => {
    if (!ready) {
      return;
    }
    const chromeServices = { edge, pro, research };
    if (isNavChromeLogoutPending()) {
      try {
        localStorage.removeItem(NAV_CHROME_SNAPSHOT_KEY);
      } catch {
        return;
      }
      applyNavChromeDocumentAttributes('anon', LOGGED_OUT_SERVICES, true);
      return;
    }
    writeNavChromeSnapshot(user, chromeServices);
    applyNavChromeDocumentAttributes(user, chromeServices, true);
  }, [edge, pro, ready, research, user]);
};
